import React from 'react';

import IconButton from 'components/common/IconButton';

import UploadEPST from 'components/uploads/UploadEPST';

const TableActions = ({ handleOpen, handleLoad }) => {
     
    return (
        <div id="orders-actions">
            <IconButton
                variant="falcon-default"
                size="sm"
                icon="plus"
                transform="shrink-3"
                className="me-2"
                iconAlign="middle"
                onClick={handleOpen} >
                <span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
                    Nuevo
                </span>
            </IconButton>
            <UploadEPST onSubmitFile={handleLoad} />
        </div>
    );
}

export default TableActions;